import { api as com, apiFuns } from 'sw-hic'

const { genStandard } = apiFuns

// 服务路径前缀 — 对应后端微服务名称
const svc = '/api/schedule'
const md = '/api/md'

const api = {
    Dict: com.Dict,
    Staff: genStandard('staff', md),        // 医护人员
    ShiftType: genStandard('shiftType', svc),        // 班次
    ShiftTypeSeries: genStandard('shiftTypeSeries', svc),  // 班次系列 (可编辑)
    Schedule: {
        ...genStandard('scheduleEntry', svc),
        batchAdd: (data) => apiFuns.post(`${svc}/scheduleEntry/batch`, data),
        lastEntry: (staffId, date) => apiFuns.get(`${svc}/scheduleEntry/lastEntry`, { staffId, date })
    }, // 排班记录
    StaffOrder: {
        getOrder: (titleType) => apiFuns.get(`${svc}/staffOrder`, { titleType }),
        saveOrder: (data)     => apiFuns.post(`${svc}/staffOrder/save`, data)
    }, // 员工行排序
}

export default api
